import * as React from 'react';

const StarIcon = ({
  height = '12px',
  width = '12px',
  fillColor = '#FFCC65',
  ...props
}: {
  height?: string;
  width?: string;
  fillColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <mask
      id="mask0"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={12}
      height={12}
    >
      <rect width="12" height="12" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0)">
      <path
        d="M2.9125 10.5L3.725 6.9875L1 4.625L4.6 4.3125L6 1L7.4 4.3125L11 4.625L8.275 6.9875L9.0875 10.5L6 8.6375L2.9125 10.5Z"
        fill={fillColor}
      />
    </g>
  </svg>
);

export default StarIcon;
